import { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, GradeOptions, StudentSexOptions } from "../../../../../../../../_helpers/Helpers";
import { useSchoolReportStudentsUIContext } from "../SchoolReportStudentsUIContext";

const prepareFilter = (queryParams, values) => {
  let { studentNumber, name, surname, sex, grade, section } = values;
  studentNumber = studentNumber === "" ? null : studentNumber;
  const newQueryParams = { ...queryParams };
  const filter = { studentNumber, name, surname, sex, grade, section };
  newQueryParams.filter = filter;  
  return newQueryParams;
};

export function SchoolReportStudentsFilter() {
  // School Report Students UI Context
  const schoolReportStudentsUIContext = useSchoolReportStudentsUIContext();
  const schoolReportStudentsUIProps = useMemo(() => {
    return {
      setQueryParams: schoolReportStudentsUIContext.setQueryParams,
      queryParams: schoolReportStudentsUIContext.queryParams,
    };
  }, [schoolReportStudentsUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(schoolReportStudentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, schoolReportStudentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      schoolReportStudentsUIProps.setQueryParams(newQueryParams);
    }
  };

  const studentSexOptions = FilterOptions.concat(StudentSexOptions);
  const gradeOptions = FilterOptions.concat(GradeOptions);
    
  return (
    <Formik
      initialValues={{
        studentNumber: "",
        name: "",
        surname: "",
        section: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="credit"
                min={1}
                placeholder="Öğrenci Numarası"
                onBlur={handleBlur}
                value={values.studentNumber}
                onChange={(e) => {
                  setFieldValue("studentNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Numarası</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={studentSexOptions}
                value={values.sex}
                placeholder="Cinsiyeti"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sex", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cinsiyeti</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="section"
                placeholder="Şube"
                onBlur={handleBlur}
                value={values.section}
                onChange={(e) => {
                  setFieldValue("section", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}